// src/utils/estimates.js

// Default realistic-ish ancestor count. You can let user edit this.
export const DEFAULT_TOTAL_ANCESTORS = 15000000;

// Clean parse of numeric answers (safe)
export function safeParseNumber(x) {
  if (typeof x === "number") return x;
  if (!x) return 0;
  // remove commas and non-digit except dot
  const clean = String(x).replace(/[^\d.]/g, "");
  const n = Number(clean);
  return Number.isFinite(n) ? n : 0;
}

// Persist history to localStorage
const HISTORY_KEY = "ancestral_query_history_v1";
export function saveToHistory(record) {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    arr.unshift(record);
    localStorage.setItem(HISTORY_KEY, JSON.stringify(arr.slice(0, 50)));
  } catch (e) {
    // ignore
  }
}
export function loadHistory() {
  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch (e) {
    return [];
  }
}
